exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Space-module__space___H9Ydr{display:flex;justify-content:center;align-items:center;height:var(--app-height);width:100vw;background-color:#303b8c;position:relative;overflow:hidden}.Space-module__space___H9Ydr .Space-module__background___b8nG2{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;position:absolute}", ""]);

// exports
exports.locals = {
	"space": "Space-module__space___H9Ydr",
	"background": "Space-module__background___b8nG2"
};